import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "regiao-anuncio",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.ativo ? _ctx.mensagem : _ctx.concluido), 1))
}